import { AppRoutes } from '@bvi/admin-panel/pages/routes';

import { withProviders } from './providers';

export const initApp = withProviders(() => <AppRoutes />);
